"use strict";

var Shipment = require('../../shipping/Shipment');

function isShipment(obj) {
  return Object.prototype.isPrototypeOf.call(Shipment.prototype, obj);
}

module.exports = isShipment;